import React, { useContext } from 'react'
import usePermissionResolution from '@broker-crm-common/Permission/usePermissionResolution'
import Cookies from 'js-cookie'
import { Navigate } from 'react-router-dom'

import { getUserOrganisationIds, UserContext } from '@acre/utils'
import { PermissionGateName, PermissionScopeType } from '@acre/graphql'

import { checkIfFirstTimeUser } from '../pages/Onboarding/Onboarding.helpers'

export const RedirectOnRoot = () => {
  const user = useContext(UserContext)

  const { isInitialCallComplete, gates } = usePermissionResolution({
    inputs: [
      {
        gates: [PermissionGateName.ViewCaseCompliance],
        entityIdsCollection: {
          [PermissionScopeType.organisation]: user ? getUserOrganisationIds({ user }).all : [],
        },
      },
      {
        gates: [PermissionGateName.EditCase],
        entityIdsCollection: {
          [PermissionScopeType.organisation]: user ? getUserOrganisationIds({ user }).all : [],
        },
      },
    ],
    skip: !user,
  })

  if (!isInitialCallComplete) {
    return null
  }

  const redirect = Cookies.get('login_redirect')

  const isComplianceUser =
    gates.includes(PermissionGateName.ViewCaseCompliance) && !gates.includes(PermissionGateName.EditCase)

  const { isFirstTimeUsingAcre } = checkIfFirstTimeUser(user)

  if (redirect) {
    Cookies.remove('login_redirect')
  }

  let path = '/cases/compliance-view'

  if (isFirstTimeUsingAcre) {
    path = '/welcome'
  } else if (!isComplianceUser) {
    path = redirect || '/cases/board-view'
  }

  return <Navigate to={path} />
}
